// Debug file for PETPAL Frontend - DISABLED
// console.log('🔍 PETPAL Debug Started');

// Check if Vue is loaded
// console.log('Vue version:', window.Vue ? 'Loaded' : 'Not loaded');

// Check if Inertia is loaded
// console.log('Inertia:', window.Inertia ? 'Loaded' : 'Not loaded');

// Check if i18n is loaded
// console.log('i18n:', window.i18n ? 'Loaded' : 'Not loaded');

// Check if Ziggy is loaded
// console.log('Ziggy:', window.route ? 'Loaded' : 'Not loaded');

// Check current page data
// console.log('Current page:', window.page);

// Check if app element exists
// const appElement = document.getElementById('app');
// console.log('App element:', appElement ? 'Found' : 'Not found');

// if (appElement) {
//     console.log('App element content:', appElement.innerHTML);
//     console.log('App element data-page:', appElement.getAttribute('data-page'));
// }

// Check for any errors in the page
// const errors = document.querySelectorAll('.error, .alert-danger');
// console.log('Errors found:', errors.length);

// Check if CSS is loaded
// const stylesheets = document.querySelectorAll('link[rel="stylesheet"]');
// console.log('Stylesheets loaded:', stylesheets.length);

// Check if JavaScript files are loaded
// const scripts = document.querySelectorAll('script[src]');
// console.log('Scripts loaded:', scripts.length);

// Check for any console errors
window.addEventListener('error', function(e) {
    console.error('🚨 JavaScript Error:', e.error);
});

// Check for unhandled promise rejections
window.addEventListener('unhandledrejection', function(e) {
    console.error('🚨 Unhandled Promise Rejection:', e.reason);
});

// console.log('🔍 PETPAL Debug Complete');
